import "./App.css";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  defer,
} from "react-router-dom";
import { AuthLayout } from "Layout/AuthLayout";
import { HomeLayout } from "Layout/HomeLayout";
import { AdminRoutes, ProtectedLayout } from "Layout/AdminLayout";
import LoginPage from "Pages/LoginPage/LoginPage";
import routes from "Layout/routes";

const getUserData = () =>
  new Promise((resolve) =>
    setTimeout(() => {
      const user = window.localStorage.getItem("user");
      resolve(user);
    }, 100)
  );
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<AuthLayout />}
      loader={() => defer({ userPromise: getUserData() })}
    >
      <Route element={<HomeLayout />}>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
      </Route>

      <Route path="/admin" element={<ProtectedLayout />}>
        {AdminRoutes(routes)}
      </Route>
    </Route>
  )
);
